import { userConstants } from "../../constants/ActionTypes";
const initialState = {
   merchantrouteList:[]
};

export function merchantRouteList(state = initialState, action) {
    switch (action.type) {  
        case userConstants.ROUTELIST:
            return {
                ...state,
                ...action.payload
            };
        default:
            return state
    }
}